package com.milta.core.localization.translations.sq

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Ekipa",
    statusActive = "Aktiv",
    errorGeneric = "Ndodhi një gabim. Ju lutemi provoni përsëri.",
    monthNames = listOf("janar", "shkurt", "mars", "prill", "maj", "qershor", "korrik", "gusht", "shtator", "tetor", "nëntor", "dhjetor"),
    enterpriseSectionLabel = "Shoferët e ekipit",
    enterpriseEmptyHint = "Ende nuk keni asnjë shofer në ekipin tuaj.",
    noEnterpriseFound = "Asnjë ndërmarrje e lidhur me llogarinë tuaj.",
    columnHeaderDriver = "Shofer",
    columnHeaderStatus = "Statusi",
    columnHeaderActions = "Veprime",
    addDriverSectionTitle = "Shto një shofer",
    addDriverCodePlaceholder = "Kodi Milta — p.sh. MTA-28371",
    addDriverButton = "Shto këtë shofer",
    addDriverErrorInvalidCode = "Ju lutemi vendosni një kod të vlefshëm.",
    addDriverErrorNotFound = "Kod i pavlefshëm ose i përdorur tashmë.",
    addDriverErrorAlreadyMember = "Ky shofer është tashmë pjesë e ekipit tuaj.",
    addDriverErrorLinkedAccountIsEnterprise = "Ky llogari është një ndërmarrje dhe nuk mund të shtohet si shofer.",
    addDriverErrorLimitReached = "Kufiri u arrit: një ndërmarrje nuk mund të ketë më shumë se 10 anëtarë, përfshirë ju. Hiqni një shofer për të shtuar një tjetër.",
    addDriverErrorEnterpriseSubscriptionInactive = "Abonimi i Ndërmarrjes suaj ka skaduar: rinovojeni për të shtuar një shofer.",
    driverDetailTitle = "Detajet e shoferit",
    driverDetailPhoneLabel = "Telefoni",
    removeDriverButton = "Hiq",
    removeDriverDialogTitle = "Të hiqet ky shofer?",
    removeDriverDialogMessagePrefix = "Jeni gati të hiqni",
    removeDriverDialogMessageSuffix = "nga ekipi juaj. Llogaria e tij/saj Milta do të mbetet aktive.",
    removeDriverErrorNotFound = "Shoferi nuk u gjet.",
    removeDriverErrorOnActiveDelivery = "Ky shofer aktualisht është duke bërë një dërgesë dhe nuk mund të hiqet.",
    removeDriverErrorLastOwner = "Ju jeni i vetmi menaxher i kësaj ndërmarrjeje. Shtoni një llogari tjetër Ndërmarrje përpara se të hiqni veten nga ekipi.",
)
